import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { RecordingInfoViewModel } from "../ViewModels/RecordingViewModel";

const tabBorderStyle = 'solid 1px #afafaf';

const styles = {
    tab: {
        //borderBottom: tabBorderStyle,
        borderRadius: 0,
    },
    endTab: {
        //borderBottom: tabBorderStyle,
        borderRadius: 0,
        borderRight: '1px black solid'
    },
    selectedTab: {
        backgroundColor: '#1d8abf',
        color: '#fff',
        borderTop: tabBorderStyle,
        borderLeft: tabBorderStyle,
        borderRight: tabBorderStyle,
        borderRadius: 0,
        '&:hover': {
            backgroundColor: '#1d8abf'
        }
    }
}

interface IPrimaryCallTabsProps {
    index: number;
    setIndex: (index: number) => void;
    calls: RecordingInfoViewModel;
}

export default function PrimaryCallTabs(props: IPrimaryCallTabsProps) {
    return (
        <Box >
            <Stack direction="row">
                {
                    props.calls.recordings.map((recording, i) =>
                        <Button
                            key={i}
                            onClick={() => props.setIndex(i)}
                            fullWidth
                            sx={props.index === i ? styles.selectedTab : i === props.calls.recordings.length - 1 ? styles.endTab : styles.tab}
                        >
                            {
                                recording.callLength ?
                                    `Call ${i + 1} - ${recording.callLength}`
                                    :
                                    `Call ${i + 1} - 00:00:00`
                            }
                        </Button>
                    )
                }
            </Stack>
        </Box >
    )
}